import React, { useState, useEffect, useCallback } from 'react';
import { Table, AutoComplete, Input, Modal, Form, Button, Tag, message } from 'antd';
import { Api_VariavelGlobal } from '../global';

const DeliveryList = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [options, setOptions] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [deliverySelecionado, setDeliverySelecionado] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const formatarData = (dataISO) => {
    const data = new Date(dataISO);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
    const segundos = String(data.getSeconds()).padStart(2, '0');
    return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
  };

  const fetchDeliveries = useCallback(async () => {
    try {
      const response = await fetch(`${Api_VariavelGlobal}/api/delivery`);
      const deliveries = await response.json();
      const deliveriesOrdenados = deliveries
        .sort((a, b) => b.STATUS - a.STATUS)
        .sort((a, b) => new Date(b.DATA) - new Date(a.DATA))
        .map((delivery) => ({
          key: delivery.ID_DELIVERY,
          bairro: delivery.BAIRRO,
          km: delivery.KM,
          data: formatarData(delivery.DATA),
          status: delivery.STATUS,
        }));

      setData(deliveriesOrdenados);
      setFilteredData(deliveriesOrdenados);
    } catch (error) {
      console.error('Erro ao buscar os deliveries:', error);
      message.error('Erro ao buscar os deliveries.');
    }
  }, []);

  useEffect(() => {
    fetchDeliveries();
  }, [fetchDeliveries]);

  const handleSearch = (value) => {
    setSearchValue(value);
    const filtered = data.filter(
      (delivery) =>
        delivery.bairro.toLowerCase().includes(value.toLowerCase()) ||
        delivery.km.toString().includes(value) ||
        delivery.data.includes(value)
    );
    setFilteredData(filtered);
    setOptions(
      filtered.map((delivery) => ({
        value: delivery.bairro,
        label: `${delivery.bairro} - ${delivery.km} KM`,
      }))
    );
  };

  const onSelect = (value) => {
    setSearchValue(value);
    const filtered = data.filter((delivery) => delivery.bairro === value);
    setFilteredData(filtered);
  };

  const showEditModal = (delivery) => {
    setDeliverySelecionado(delivery);
    setIsModalVisible(true);
  };

  const handleModalOk = async () => {
    setConfirmLoading(true);
    try {
      const response = await fetch(`${Api_VariavelGlobal}/api/delivery/${deliverySelecionado.key}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          BAIRRO: deliverySelecionado.bairro,
          KM: deliverySelecionado.km,
          STATUS: deliverySelecionado.status,
        }),
      });

      if (response.ok) {
        message.success('Delivery atualizado com sucesso!');
        setIsModalVisible(false);
        fetchDeliveries(); // Atualiza a lista após edição
      } else {
        console.error('Erro ao atualizar delivery:', response.statusText);
        message.error('Erro ao atualizar delivery.');
      }
    } catch (error) {
      console.error('Erro ao enviar os dados para a API:', error);
      message.error('Erro ao enviar os dados para a API.');
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: 'Bairro',
      dataIndex: 'bairro',
      key: 'bairro',
    },
    {
      title: 'R$/KM',
      dataIndex: 'km',
      key: 'km',
    },
    {
      title: 'Data',
      dataIndex: 'data',
      key: 'data',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const isActive = status === 1;
        return <Tag color={isActive ? 'blue' : 'red'}>{isActive ? 'Ativo' : 'Inativo'}</Tag>;
      },
    },
    {
      title: 'Ação',
      key: 'acao',
      render: (_, delivery) => (
        <Button type="link" onClick={() => showEditModal(delivery)}>
          Editar
        </Button>
      ),
    },
  ];

  return (
    <>
      <AutoComplete
        popupMatchSelectWidth={252}
        style={{ width: 300, marginBottom: 10 }}
        value={searchValue}
        options={options}
        onSelect={onSelect}
        onSearch={handleSearch}
        size="large"
      >
        <Input.Search size="large" placeholder="Buscar bairro" enterButton />
      </AutoComplete>

      <Table 
        columns={columns} 
        dataSource={filteredData} 
        size="small"
        />

      <Modal
        title="Editar Delivery"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        confirmLoading={confirmLoading}
      >
        <Form layout="vertical">
          <Form.Item label="Bairro">
            <Input
              value={deliverySelecionado?.bairro}
              onChange={(e) =>
                setDeliverySelecionado((prev) => ({ ...prev, bairro: e.target.value }))
              }
            />
          </Form.Item>
          <Form.Item label="R$/KM">
            <Input
              value={deliverySelecionado?.km}
              onChange={(e) => setDeliverySelecionado((prev) => ({ ...prev, km: e.target.value }))}
            />
          </Form.Item>
          <Form.Item label="Status">
            <Input
              value={deliverySelecionado?.status}
              onChange={(e) =>
                setDeliverySelecionado((prev) => ({
                  ...prev,
                  status: parseInt(e.target.value, 10),
                }))
              }
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DeliveryList;
